import React from 'react';
import { AppSettingsContext, resolveAppDisplayTitle } from '../../contexts/AppSettingsProvider';

export default function BrandingAppTitle() {
  return (
    <AppSettingsContext.Consumer>
      {(settings) => <>{resolveAppDisplayTitle(settings)}</>}
    </AppSettingsContext.Consumer>
  );
}
